module.exports = __webpack_public_path__ + "mail_box_3.52ab909a381d432803ff03e383297c91.svg";